<template>
	<div>

		<div v-if="init">

            <div v-if="filteredVacations">
                <div style="max-height:72vh;" class="border border-gray-300 mb-12 mt-12 overflow-x-scroll" v-if="filteredVacations.length > 0">
                    <table class="table w-full">
                        <thead>
                            <tr>
                                <th style="top: -1px;" class="sticky z-20">Request ID</th>
                                <th style="top: -1px;" class="sticky z-20">From</th>
                                <th style="top: -1px;" class="sticky z-20">To</th>
                                <th style="top: -1px;" class="sticky z-20">Hours</th>
                                <th style="top: -1px;" class="sticky z-20">Days</th>
                                <th style="top: -1px;" class="sticky z-20">Comments</th>
                                <th style="top: -1px;" class="sticky z-20" v-if="isSubordinate">
                                    <CellType>
                                        <template v-slot:type>Confirmed</template>
                                        <template v-slot:by>by team leader</template>
                                    </CellType>
                                </th>
                                <th style="top: -1px;" class="sticky z-20">
                                    <CellType>
                                        <template v-slot:type>Approved</template>
                                        <template v-slot:by>by manager</template>
                                    </CellType>
                                </th>
                                <th style="top: -1px;" class="sticky z-20">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(vacation, index) in filteredVacations" :key="vacation._key">
                                <td>
                                    <div class="flex">
                                        <Zondicon icon="news-paper" class="w-4 mr-4 fill-current" style="height: 20px" />
                                        <span>Req #{{vacation._key.substring(0,3)}}</span>
                                    </div>
                                </td>
                                <td>{{ formatDate(vacation.from) }}</td>
                                <td>{{ formatDate(vacation.to) }}</td>
                                <td class="font-bold">{{ vacation.hours }}</td>
                                <td class="font-bold">{{ getVacationDays(vacation.hours) }}</td>
                                <td>
                                    <span class="text-xs flex justify-between" v-if="vacation.comments">
                                        <span>
                                            <span>{{ vacation.comments.substr(0, 20) }}</span>
                                            <span v-if="vacation.comments.length > 20">...</span>
                                        </span>
                                        <span 
                                            class="underline cursor-pointer"
                                            v-if="vacation.comments.length > 20"
                                            @click="commentModal = true; comment = vacation.comments">
                                            show more
                                        </span>
                                    </span>
                                </td>

                                <td v-if="isSubordinate">
                                    <div v-if="vacation.confirmedDate">
                                        <div class="flex items-center leading-tight">
                                            <div 
                                                :class="{'bg-green-500': vacation.confirmed === true, 'bg-red-500': vacation.confirmed === false}"
                                                class="w-2 h-2 rounded-full mr-2"></div>
                                            <div v-if="vacation.confirmed === true">confirmed</div>
                                        </div>
                                        <div class="leading-tight">
                                            <span class="text-gray-500 italic text-xs">{{ formatDate(vacation.confirmedDate, 1) }}</span>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="flex items-center leading-tight">
                                            <div class="w-2 h-2 bg-orange-400 rounded-full mr-2"></div>
                                            <div>waiting for confirmation</div>
                                        </div>
                                    </div>
                                </td>

                                <td>

                                    <div v-if="vacation.approvedDate">
                                        <div class="flex items-center leading-tight">
                                            <div 
                                                :class="{'bg-green-500': vacation.approved === true, 'bg-red-500': vacation.approved === false}"
                                                class="w-2 h-2 rounded-full mr-2"></div>
                                            <div v-if="vacation.approved === true">approved</div>
                                            <div v-if="vacation.approved === false">declined</div>
                                        </div>
                                        <div class="leading-tight">
                                            <span class="text-gray-500 italic text-xs">{{ formatDate(vacation.approvedDate, 1) }}</span>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="flex items-center leading-tight">
                                            <div class="w-2 h-2 bg-orange-400 rounded-full mr-2"></div>
                                            <div>waiting for approval</div>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="flex">
                                        <router-link v-if="!vacation.approvedDate && !vacation.confirmedDate" :to="{name: 'vacation-edit', params: {id: vacation._key}}" class="text-gray-600 cursor-pointer tooltip inline-block mr-4">
                                            <Zondicon icon="edit-pencil" class="w-4 fill-current" />
                                            <span class="tooltip-text -ml-4">Edit</span>
                                        </router-link>

                                        <span v-if="vacation.approvedDate || vacation.confirmedDate" class="text-gray-600 cursor-pointer tooltip inline-block mr-4" @click="showEdit = true; vacationKey = vacation._key">
                                            <Zondicon icon="edit-pencil" class="w-4 fill-current" />
                                            <span class="tooltip-text -ml-4">Edit</span>
                                        </span>

                                        <span v-if="!vacation.approvedDate" class="text-gray-600 cursor-pointer tooltip inline-block mr-4" @click="showConfirm(vacation._key)">
                                            <Zondicon icon="trash" class="w-4 fill-current" />
                                            <span class="tooltip-text -ml-4">Delete</span>
                                        </span>
                                        
                                        <router-link :to="{name: 'vacation-preview', params: {id: vacation._key}}" target="_blank" class="text-gray-600 cursor-pointer tooltip inline-block mr-4">
                                            <Zondicon icon="printer" class="w-4 fill-current" />
                                            <span class="tooltip-text -ml-4">Preview</span>
                                        </router-link>
                                    </div>
                                </td>
                                
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-else class="mb-12 mt-12">What? You do not have any vacation request yet? Aren’t you tired? <router-link class="underline" :to="{ name: 'vacation-new'}">Create one!</router-link></div>
            </div>

        </div>

        <div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>

        <SimpleModal v-if="deleteModal" @action="deleteVacation" @close="deleteModal = false" :btnClass="'btn-danger'">
			<template v-slot:title>Delete vacation request</template>
			<template v-slot:body>Are you sure you want to delete this vacation request?</template>
			<template v-slot:button>Delete</template>
		</SimpleModal>

        <SimpleModal v-if="commentModal" @close="commentModal = false" :btnClass="'btn-primary'" :doNotShowAction="true">
			<template v-slot:title>Vacation request comment</template>
			<template v-slot:body>{{ comment }}</template>
            <template v-slot:cancel>Close</template>
		</SimpleModal>

        <SimpleModal v-if="showEdit" @action="goToEdit()" @close="showEdit = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Edit vacation</template>
            <template v-slot:body>This vacation request is already approved or declined.<br><strong>If you make a change, the request will be send again.</strong><br>Are you sure you want to edit this vacation request?</template>
            <template v-slot:button>Edit</template>
        </SimpleModal>

    </div>
</template>

<script>
import { db, auth } from '@/firebase'
import { mapState } from "vuex";
import moment from 'moment';
import Zondicon from 'vue-zondicons'

import SimpleModal from '@/components/SimpleModal.vue'
import CellType from '@/components/CellType.vue'

export default {

    data() {
        return {
            vacationKey: null,
            deleteModal: false,
            commentModal: false,
            comment: '',
            showEdit: false,
            vacationKey: null
        }
    },

    computed: {
        init() {
            return true
        },

        ...mapState({
			currentUser: state => state.user.info,
			currentUserVacations: state => state.user.vacations,
			users: state => state.users,
		}),
        
        filteredVacations() {
            if (this.currentUserVacations) {
                return this.currentUserVacations.sort((a, b) => {
                    return new Date(b.from.seconds * 1000) - new Date(a.from.seconds * 1000)
                })
            }
            return false;
        },

        isSubordinate() {
            if (this.users) {
                return this.users.find(user => {
                    if (user.subordinates.indexOf(this.currentUser.uid) > -1 && user.role !== 'superadmin') return user
                })
            }
            return false
        },
    },

    components: {
		SimpleModal,
		Zondicon,
        CellType
	},

    methods: {
        formatDate(date, hours) {
            var format = 'DD.MM.YYYY';
            if (hours) format += ' hh:mm';
            return moment(date.seconds * 1000).format(format);
        },

        showConfirm(key) {
			this.deleteModal = true
			this.vacationKey = key
		},

        getVacationDays(hours) {
            var workingHours = (this.currentUser.isPartTime) ? this.currentUser.partTime : 8;
            return Math.round((hours/workingHours) * 10) / 10;
        },

        goToEdit() {
            this.$router.push(
                { 
                    name: 'vacation-edit', 
                    params: { 
                        id: this.vacationKey 
                    } 
                }
            )
        },

        deleteVacation() {
            db
			.collection("vacations")
			.doc(this.vacationKey)
			.delete()
			.then(() => {
				this.deleteModal = false
				this.$toasted.show(`Deleted successfully!`, {
					type: 'success'
				})
			})
			.catch(error => {
				this.deleteModal = false
				this.$toasted.show(`Error: ${error}`, {
					type: 'error'
				})
			});
        },
        
        // unlockVacation() {
        //     db
        //     .collection('vacations')
        //     .doc(this.vacationKey)
        //     .update({
        //         approved: null,
        //         approvedDate: null,
        //         approvedBy: null
        //     })
        //     .then(() => {
        //         this.showUnlock = false
        //         this.$toasted.show(`Unlocked successfully!`, {
        //             type: 'success'
        //         })
        //     })
        //     .catch(error => {
        //         this.showUnlock = false
        //         this.$toasted.show(`Error: ${error}`, {
        //             type: 'error'
        //         })
        //     });
        // },
    },

    created() {

        if (!this.currentUserVacations) this.$store.dispatch('user/getVacations');
        if (!this.users) this.$store.dispatch('getUsers')
		this.$store.commit('SET_TITLE', 'My vacation requests');

	}

}

</script>